import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import CompanyNameCombineModel from "../models/CompanyNameCombineModel";

export interface GetCompanyNameCombineByIdParam {
    id: string,
}

export interface DeleteCompanyNameCombineByIdParam {
    id: string,
}

const CompanyNameCombineApi = {
    GetAll() {
        return Api.get<unknown, BaseResponse<CompanyNameCombineModel[]>>("/api/CompanyNameCombine/GetAll", null);
    },
    Save(param: CompanyNameCombineModel) {
        return Api.post<CompanyNameCombineModel, BaseResponse<CompanyNameCombineModel>>("/api/CompanyNameCombine/Save", param);
    },
    GetById(param: GetCompanyNameCombineByIdParam) {
        return Api.get<GetCompanyNameCombineByIdParam, BaseResponse<CompanyNameCombineModel>>("/api/CompanyNameCombine/GetById", param);
    },
    Delete(param: DeleteCompanyNameCombineByIdParam) {
        return Api.post<DeleteCompanyNameCombineByIdParam, BaseResponse<CompanyNameCombineModel>>("/api/CompanyNameCombine/Delete", param);
    },
    GetAllCompanyNames() {
        return Api.get<unknown, BaseResponse<string[]>>("/api/CompanyNameCombine/GetAllCompanyNames", null);
    },
};
export default CompanyNameCombineApi;